import { render, staticRenderFns } from "./tabelado.vue?vue&type=template&id=5f6abade"
import script from "./tabelado.vue?vue&type=script&lang=js"
export * from "./tabelado.vue?vue&type=script&lang=js"
import style0 from "./tabelado.vue?vue&type=style&index=0&id=5f6abade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports